<template>
  <div id="new_i">
    <top></top>
    <div class="main">
      <div class="content">
        <p class="new_i_title">新建邀请函</p>
        <div class="new_i_border"></div>
        <div class="new_i_form">
          <el-form
            :model="invitationForm"
            :rules="invitationRules"
            ref="invitationRef"
            label-position="top"
          >
            <el-form-item label="邀请人" prop="invitation_name">
              <el-input
                v-model="invitationForm.invitation_name"
                clearable
                placeholder="请输入邀请人"
              ></el-input>
            </el-form-item>
            <el-form-item label="模板类型" prop="cover_type">
              <el-radio
                v-model="invitationForm.cover_type"
                @change="radio_change"
                :label="1"
                >固定模板</el-radio
              >
              <el-radio
                v-model="invitationForm.cover_type"
                @change="radio_change"
                :label="2"
                >自定义模板</el-radio
              >
            </el-form-item>
            <el-form-item
              label="封面图"
              prop=""
              v-if="invitationForm.cover_type == 1"
            >
              <el-image class="new_i_uploader" :src="cover_image_1"></el-image>
            </el-form-item>
            <el-form-item
              label="封面图"
              prop="cover"
              v-if="invitationForm.cover_type == 2"
            >
              <div class="new_i_uploader">
                <singleImageUpload
                  @handleUploading="handleUploading"
                  @handleUploadSuccess="handleUploadSuccess"
                  @handlePreviewImage="handlePreviewImage"
                  @handleDeleteImage="handleDeleteImage"
                  :imageSrc="invitationForm.cover"
                ></singleImageUpload>
              </div>
              <div>建议尺寸 1080*1920</div>
            </el-form-item>
            <el-form-item
              label="批量添加"
              prop="is_batch_add"
              v-if="mode === 'add'"
            >
              <el-switch
                active-color="#E40080"
                @change="handleSwitchChange"
                v-model="invitationForm.is_batch_add"
              >
              </el-switch>
            </el-form-item>
            <el-form-item
              label="座位区域"
              prop="seat_region"
              v-if="mode === 'add'"
            >
              <el-input
                v-model="invitationForm.seat_region"
                placeholder="请输入座位区域"
              ></el-input>
            </el-form-item>
            <el-form-item label="座位号" prop="seat_number_start">
              <el-input
                class="new_i_seat_number"
                :placeholder="
                  invitationForm.is_batch_add
                    ? '请输入座位号开始区间'
                    : '请输入座位号'
                "
                v-model="invitationForm.seat_number_start"
              ></el-input>
              <el-input
                v-if="invitationForm.is_batch_add"
                class="new_i_seat_number"
                placeholder="请输入座位号结束区间"
                v-model="invitationForm.seat_number_end"
              ></el-input>
            </el-form-item>
            <el-form-item label="邀请函类型" prop="is_vip">
              <el-radio
                v-for="(item, index) in ticket_type_options"
                :key="index"
                v-model="invitationForm.is_vip"
                :label="item.value"
                >{{ item.name }}</el-radio
              >
            </el-form-item>
            <el-form-item label="是否展示座位号" prop="is_show_seat">
              <el-switch
                active-color="#E40080"
                v-model="invitationForm.is_show_seat"
                :disabled="mode === 'edit'"
              ></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <div class="new_i_button">
          <div class="declare_borderButton" @click="back">返回</div>
          <div class="declare_fillButton" @click="verifyForm">提交</div>
        </div>
      </div>
    </div>
    <maskLayer
      :text="maskLayerText"
      :show="maskLayerShow"
      :type="maskLayerType"
      :imgSrc="invitationForm.cover"
      @handleCancelPreviewImage="handleCancelPreviewImage"
    ></maskLayer>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import singleImageUpload from "../../components/singleImageUpload.vue";
import maskLayer from "../../components/maskLayer.vue";
import {
  getDictionary,
  batchGenerationInvitation,
  getInvitationDetail,
  modifyInvitationContent,
  getLastTimeCoverImage,
} from "../../api/api";
export default {
  name: "newInvitaition",
  components: { top, singleImageUpload, maskLayer },
  created() {
    this.activityId = this.$route.query.activityId;
    this.mode = this.$route.query.mode;
    this.invitationId = this.$route.query.invitationId;
    this.getDict();
    if (this.mode === "add") {
      this.getCover();
    }
  },
  data() {
    var checkSeatNumber = (rule, value, callback) => {
      if (this.invitationForm.is_batch_add) {
        if (this.invitationForm.seat_number_start === "") {
          callback(new Error("请输入座位开始区间！"));
        } else if (this.invitationForm.seat_number_end === "") {
          callback(new Error("请输入座位结束区间！"));
        } else if (
          Number(this.invitationForm.seat_number_start) >
          Number(this.invitationForm.seat_number_end)
        ) {
          callback(new Error("座位结束区间号必须大于等于座位开始区间号"));
        } else {
          callback();
        }
      } else {
        if (this.invitationForm.seat_number_start === "") {
          callback(new Error("请输入座位号！"));
        } else {
          callback();
        }
      }
    };
    return {
      mode: "add",
      activityId: "",
      invitationId: "",
      ticket_type_options: [],
      cover_image_1:
        "https://oss.indata3.com/cfa/uploads/images/20260817/445db3b0a4a5a5a2628793206a5c7439.jpg",
      invitationForm: {
        cover_type: 1,
        invitation_name: "",
        cover: "",
        is_batch_add: false,
        seat_region: "",
        seat_number_start: "",
        seat_number_end: "",
        is_vip: "",
        is_show_seat: true,
      },
      invitationRules: {
        cover: [
          {
            required: true,
            message: "请上传封面图！",
            trigger: "change",
          },
        ],
        is_batch_add: [
          {
            required: true,
            message: "请选择是否批量上传",
            trigger: "change",
          },
        ],
        seat_region: [
          {
            required: true,
            message: "请输入座位区域",
            trigger: "blur",
          },
        ],
        seat_number_start: [
          {
            required: true,
            validator: checkSeatNumber,
            trigger: "blur",
          },
        ],
        is_vip: [
          {
            required: true,
            message: "请选择邀请函类型",
            trigger: "change",
          },
        ],
      },
      maskLayerShow: false,
      maskLayerType: "",
      maskLayerText: "",
    };
  },
  methods: {
    radio_change(e) {
      if (e == 2) {
        this.invitationForm.cover =
          this.cover_image_1 == this.invitationForm.cover_image
            ? ""
            : this.invitationForm.cover_image;
      }
    },
    async getCover() {
      const res = await getLastTimeCoverImage(
        "activities_id=" + this.activityId
      );
      if (
        typeof res.data.cover_image === "string" &&
        res.data.cover_image.length > 0
      ) {
        this.invitationForm.cover = res.data.cover_image;
      }
    },
    async getDict() {
      let dictionaryString = "?type=ticket_type";
      const res = await getDictionary(dictionaryString);
      if (res.code == 1) {
        this.ticket_type_options = res.data.ticket_type;
        if (this.mode === "edit") {
          this.getDetail();
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    async getDetail() {
      let data = {
        id: this.invitationId,
        activities_id: this.activityId,
      };
      const res = await getInvitationDetail(this.$qs.stringify(data));
      if (res.code == 1) {
        this.invitationForm.cover = res.data.cover_image;
        this.invitationForm.invitation_name = res.data.invitation_name;
        this.invitationForm.cover_type = res.data.cover_type;
        this.invitationForm.seat_number_start = res.data.seat_number;
        this.invitationForm.is_vip = String(res.data.ticket_type);
        this.invitationForm.is_show_seat =
          res.data.is_show_seat == 1 ? true : false;
      } else {
        this.$message.error(res.msg);
      }
    },
    verifyForm() {
      this.$refs["invitationRef"].validate((valid, field) => {
        if (valid) {
          this.submitForm();
        } else {
          let arr = Object.keys(field);
          let tips = field[arr[0]][0].message;
          this.$message.error(tips);
          return false;
        }
      });
    },
    submitForm() {
      let batchTips = "请问您确定要批量生成邀请函吗？";
      let singleTips = "请问您确定要生成邀请函吗？";
      this.$confirm(
        this.invitationForm.is_batch_add ? batchTips : singleTips,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          if (this.mode === "add") {
            this.handleCreateInvitation();
          } else if (this.mode === "edit") {
            this.handleModifyInvitation();
          } else {
            this.$message.error("邀请函处理方式出错，请联系管理员！");
          }
        })
        .catch(() => {});
    },
    async handleCreateInvitation() {
      this.maskLayerShow = true;
      this.maskLayerType = "upload";
      this.maskLayerText = "正在生成中...";
      let data = {
        activities_id: this.activityId,
        invitation_name: this.invitationForm.invitation_name,
        cover_type: this.invitationForm.cover_type,
        cover_image:
          this.invitationForm.cover_type == 1
            ? this.cover_image_1
            : this.invitationForm.cover,
        seat_area: this.invitationForm.seat_region,
        start_range: this.invitationForm.seat_number_start,
        end_range: this.invitationForm.is_batch_add
          ? this.invitationForm.seat_number_end
          : "",
        ticket_type: this.invitationForm.is_vip,
        is_show_seat: this.invitationForm.is_show_seat ? 1 : 0,
      };
      const res = await batchGenerationInvitation(data);
      if (res.code == 1) {
        this.maskLayerShow = false;
        this.maskLayerType = "";
        this.maskLayerText = "";
        let message = "";
        if (res.data.existing_seats && res.data.existing_seats.length > 0) {
          let str = "";
          res.data.existing_seats.forEach((item) => {
            str += item + " ";
          });
          message = `部分生成成功:` + str;
        } else {
          message = res.msg;
        }
        this.$message({
          message,
          type: "success",
          duration: 1500,
        });
        let timer = setTimeout(() => {
          this.$router.back();
          clearTimeout(timer);
        }, 1500);
      } else {
        this.maskLayerShow = false;
        this.maskLayerType = "";
        this.maskLayerText = "";
        this.$message.error(res.msg);
      }
    },
    async handleModifyInvitation() {
      let data = {
        cover_type: this.invitationForm.cover_type,
        invitation_name: this.invitationForm.invitation_name,
        cover_image:
          this.invitationForm.cover_type == 1
            ? this.cover_image_1
            : this.invitationForm.cover,
        activities_id: this.activityId,
        id: this.invitationId,
        seat_number: this.invitationForm.seat_number_start,
        ticket_type: this.invitationForm.is_vip,
      };
      const res = await modifyInvitationContent(data);
      if (res.code == 1) {
        this.$message({
          message: res.msg,
          type: "success",
          duration: 1500,
        });
        let timer = setTimeout(() => {
          this.$router.back();
          clearTimeout(timer);
        }, 1500);
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSwitchChange(res) {
      if (!res) {
        this.invitationForm.seat_number_end = "";
        this.$refs.invitationRef.validateField("seat_number_start");
      }
    },
    handleUploading() {
      this.maskLayerShow = true;
      this.maskLayerType = "upload";
      this.maskLayerText = "正在上传中...";
    },
    handleUploadSuccess(src) {
      this.maskLayerShow = false;
      this.maskLayerType = "";
      if (src) {
        this.invitationForm.cover = src;
      }
    },
    handlePreviewImage() {
      this.maskLayerShow = true;
      this.maskLayerType = "preview";
    },
    handleDeleteImage() {
      this.invitationForm.cover = "";
    },
    handleCancelPreviewImage() {
      this.maskLayerShow = false;
      this.maskLayerType = "";
    },
    back() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.new_i_title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}
.new_i_border {
  width: 100%;
  height: 5px;
  background-color: #f3f3f3;
  margin: 20px 0;
}
.new_i_form {
  /deep/ .el-radio__input.is-checked {
    .el-radio__inner {
      border-color: #409eef;
      background-color: #409eef;
    }
  }
  .new_i_uploader {
    height: 160px;
    width: 160px;
    /deep/.el-image__inner {
      object-fit: contain;
    }
  }
  .el-input {
    width: 20%;
  }
  .new_i_seat_number {
    margin-right: 20px;
  }
}
.new_i_button {
  display: flex;
  width: 267px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 40px;
  justify-content: space-between;
  align-items: center;
}
</style>